module.exports = __webpack_public_path__ + "img/o_1dr89oma6nrm130lam14o6ji19.37044fa1.png";